import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BlockSpace } from 'components/atoms/space';
import { Filter } from 'components/molecules/filters/types';
import { SelectedConditions } from '../selected-conditions/selected';

export const SelectedValues = ({
  selectedCondition,
  showType,
  customOptionTrigger,
}: {
  showType?: boolean;
  selectedCondition: Filter;
  customOptionTrigger?: boolean;
}) => {
  const { type, criteria } = selectedCondition;

  return (
    <BlockSpace direction="vertical" size="small">
      {type && showType ? (
        <FormattedMessage
          id="settings.integrations.sf.automation.create.matches.condition"
          values={{
            i: () => (
              <i>
                <b>{type}</b>
              </i>
            ),
          }}
        />
      ) : null}

      {criteria.length ? (
        <SelectedConditions
          criteria={criteria}
          customOptionTrigger={customOptionTrigger}
        />
      ) : null}
    </BlockSpace>
  );
};
